import { CONTINENT_OPTIONS } from "../contacts/geography";
import type { ContactGeoCode } from "../types";

const NO_MATCH_CONTINENT = "__NO_MATCH__";
const CONTACT_CONTINENT_FILTER_KEY = "phone_continent_code@in";

export function buildContactGeographyListFilter(
  includedContinents: ContactGeoCode[],
  excludedContinents: ContactGeoCode[],
): Record<string, unknown> {
  const includeSet = new Set(includedContinents);
  const excludeSet = new Set(excludedContinents);

  if (!includeSet.size && !excludeSet.size) {
    return {};
  }

  const visibleContinents = includeSet.size
    ? [...includeSet].filter((code) => !excludeSet.has(code))
    : CONTINENT_OPTIONS.map((option) => option.code).filter(
        (code) => !excludeSet.has(code),
      );

  return {
    [CONTACT_CONTINENT_FILTER_KEY]: visibleContinents.length
      ? visibleContinents.join(",")
      : NO_MATCH_CONTINENT,
  };
}

/**
 * List filter that matches *only* the contacts removed by the geography
 * exclusions, so the audience builder can show how many people the operator is
 * excluding (e.g. "268 matching contacts excluded"). Returns an empty filter
 * when nothing is excluded.
 */
export function buildExcludedContactGeographyListFilter(
  excludedContinents: ContactGeoCode[],
): Record<string, unknown> {
  const excluded = [...new Set(excludedContinents)].filter(Boolean);
  if (!excluded.length) {
    return {};
  }

  return { [CONTACT_CONTINENT_FILTER_KEY]: excluded.join(",") };
}
